import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';

import { DEFAULT_CHART_HEIGHT, DEFAULT_CHART_WIDTH } from 'core/assets/constants';

@Component({
  selector: 'lms-chart-speedometer',
  templateUrl: './chart-speedometer.component.html',
  styleUrls: ['./chart-speedometer.component.scss']
})
export class ChartSpeedometerComponent implements AfterViewInit, OnChanges {
  @ViewChild('canvas', { static: false }) public canvasChart: ElementRef<HTMLCanvasElement>;
  @Input() public primaryValue: number = 0;
  @Input() public secondaryValue: number;
  @Input() public progress: number;
  @Input() public showCircle: boolean = false;
  @Input() public showHorizontal: boolean = false;
  @Input() public showHorizontalDouble: boolean = false;
  @Input() public showPercentage = true;
  @Input() public showNPS = false;
  @Input() public showMedia = false;
  @Input() public maxRange? = 100;
  @Input() public minRange? = 0;

  public chartValue: number;

  private minCircleValue = 0.73;
  private middleCircleValue = 1.5;
  private maxCircleValue = 2.27;
  private context: CanvasRenderingContext2D;

  constructor(private cd: ChangeDetectorRef) {}

  public ngAfterViewInit(): void {
    if (this.showCircle && Number.isFinite(this.progress)) {
      this.drawChart();
      this.cd.detectChanges();
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['progress'] &&
      Number.isFinite(changes['progress']['previousValue']) &&
      Number.isFinite(changes['progress']['currentValue'])
    ) {
      this.drawChart();
    }
  }

  /**
   * Draw circle chart
   * @private
   */
  private drawChart(): void {
    this.context = this.canvasChart.nativeElement.getContext('2d');

    if (!this.context) {
      return;
    }

    if (this.maxRange < 100) {
      this.primaryValue = Math.ceil(this.progress * this.maxRange);
    } else {
      this.primaryValue = Math.ceil(this.progress);
    }
    this.chartValue = this.calculateValueChart(this.primaryValue);

    this.canvasChart.nativeElement.width = DEFAULT_CHART_WIDTH;
    this.canvasChart.nativeElement.height = DEFAULT_CHART_HEIGHT;
    this.context.beginPath();
    this.context.moveTo(76, 76);
    this.context.arc(76, 76, 76, this.chartValue * Math.PI, this.maxCircleValue * Math.PI, false);
    this.context.fillStyle = '#e1e4e8';
    this.context.fill();
  }

  /**
   * Calculate the value of the circle chart
   * @param chartValue
   * @private
   */
  private calculateValueChart(chartValue: number): number {
    if (this.showNPS) {
      return this.calcNPSValue(chartValue);
    }
    return (chartValue * 270) / 100 / 180 + this.minCircleValue;
  }

  /**
   * Calculate the value of the NPS circle chart
   * @param chartValue
   * @private
   */
  private calcNPSValue(chartValue: number): number {
    if (chartValue === this.minRange) {
      return this.minCircleValue;
    }
    if (chartValue === this.maxRange) {
      return this.maxCircleValue;
    }
    if (chartValue === 0) {
      return this.middleCircleValue;
    }
    if (chartValue < 0) {
      return (
        this.middleCircleValue - Math.abs((chartValue * (this.middleCircleValue - this.minCircleValue)) / this.maxRange)
      );
    } else if (chartValue > 0) {
      return this.middleCircleValue + (chartValue * (this.maxCircleValue - this.middleCircleValue)) / this.maxRange;
    }
  }
}
